import { useCallback, useRef, useState } from "react";
import { useNotify } from "react-admin";
import PostAddIcon from "@mui/icons-material/PostAdd";
import LoadingActionButton from "server/components/LoadingActionButton";
import { importResults } from "./utils";
import ImportErrorsDialog from "./ImportErrorsDialog";

const ImportExamResultsButton = ({ exam, isFinished }) => {
  const notify = useNotify();
  const inputRef = useRef(null);

  const [errors, setErrors] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const changeHandler = useCallback(
    async event => {
      setLoading(true);

      const result = await importResults(event, exam.campaignExamId, "PUT", notify);

      if (result?.length > 0) {
        setErrors(result);
        setOpen(true);
      }

      inputRef.current.value = null;
      setLoading(false);
    },
    [notify, exam.campaignExamId],
  );

  if (!exam) {
    return null;
  }

  return (
    <>
      <input
        type="file"
        accept=".xlsx"
        style={{ display: "none" }}
        ref={inputRef}
        onChange={changeHandler}
      />
      <LoadingActionButton
        label="Добави оценки"
        icon={<PostAddIcon />}
        onClick={() => inputRef.current.click()}
        disabled={exam.examFinalized || isFinished}
        loading={loading}
      />
      <ImportErrorsDialog
        open={open}
        onClose={() => setOpen(false)}
        errors={errors}
      />
    </>
  );
};

export default ImportExamResultsButton;
